<template>
  <div class="container table-responsive">

    <!-- -------------------------  Buyer Info Modal -------------------------- -->

    <!-- Modal -->
    <div class="modal fade" id="modal_BI" tabindex="-1" aria-labelledby="modal_BI_label" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal_BI_label">Buyer Information</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="closeModalCancel"></button>
          </div>
          <div class="modal-body">
            <div class="form-group control-label">
              <label class="col-sm-2 font-weight-bold text-right">*Name</label>
              <input type="text" class="col-sm-9 text-left" required="required" v-model="name">
            </div>

            <div class="form-group control-label">
              <label class="col-sm-2 font-weight-bold text-right">*Phone</label>
              <input type="text" class="col-sm-5 text-left" required="required" v-model="phone">
            </div>

            <div class="row">
              <label class="col-sm-2 font-weight-bold text-right">*State</label>
              <select class="form-select col-sm-5 text-left" v-model="stateSel">
                <option v-for="state in stateList" :key="state">
                  {{ state }}
                </option>
              </select>
            </div>

          </div>
          <div class="modal-footer align-center">
              <button type="button" class="btn btn-secondary ml-4 ml-auto mr-auto" @click="closeModalConfirm">Confirm</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ----------------------------------------------------------------------- -->

  </div>
</template>
    
<script>
import { Modal } from 'bootstrap'
import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'BuyerInfo',
    inheritAttrs: false,

    props: {
    },
  
    mounted() {
      this.modal_BI = new Modal(document.getElementById('modal_BI'));
    },

    computed: {
    ...mapGetters([
        'buyer',
      ]),
    },

    data: () => {
      return {
        modal_BI: null,
        name: '',
        phone: '',

        stateList: ["Andhra Pradesh","Andaman and Nicobar Islands","Arunachal Pradesh","Assam","Bihar",
						"Chandigarh","Chhattisgarh","Dadar and Nagar Haveli","Daman and Diu","Delhi","Lakshadweep",
						"Puducherry","Goa","Gujarat","Haryana","Himachal Pradesh","Jammu and Kashmir","Jharkhand",
						"Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram",
						"Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura",
						"Uttar Pradesh","Uttarakhand","West Bengal"],

			stateSel: "Maharashtra",

      }
    },

  
    methods: {
      ...mapActions([
      ]),

      openModal() {
        if (!this.buyer.name || this.buyer.name=='undefined'){
          this.buyer.name = ""
        }
        
        if (!this.buyer.phone || this.buyer.phone=='undefined')
          this.buyer.phone = ""

        if (!this.buyer.state || this.buyer.state=='undefined')
          this.buyer.state = "Maharashtra"

        this.name = this.buyer.name
        this.phone = this.buyer.phone
        this.stateSel = this.buyer.state
        this.modal_BI.show()
      },

      closeModalConfirm(){
          this.$emit('onClose', this.name.trim(), this.phone.trim(), this.stateSel.trim())
          this.modal_BI.hide()
      },

      closeModalCancel(){
          this.modal_BI.hide()
      },
    },
  }
</script>
    
<style scoped lang="css">

.form-group.required.control-label:before{
   color: red;
   content: "*";
   position: absolute;
   margin-left: -0px;
}

</style>